import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { saveDriverData, getDriverListById, updateDriverData } from "../../redux/actions/DriverActions";
import { getAllStateList, getAllCityStateWiseList, getMasterVehicleList, getMasterVendorList, getAllUsersRoleWiseList,getAllUsertypeUserList } from "../../redux/actions/MasterActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import HyperDatepicker from "../../Components/Datepicker";
import { getDateTimeMysqlGivenFormatYmd } from '../../util/generalUtills';
import Preloader from "../../Components/Preloader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [stateId, setStateId] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});

    const [roleCode,setroleCode]=useState("JUNIOR_ENGINEER");
  
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    driverReducer: {
      driverLists,
      loadingDriver,
      errorsDriver,
      changedDriverStatus,
    },
    masterReducer: {
      masterStateLists,
      masterCityStateWiseLists,
      masterVehicleLists,
      masterVendorLists,
      masterUsertypeUserLists,
      masterUsersRoleWiseLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getAllStateList(auth?.accessToken));
      dispatch(getMasterVendorList(auth?.accessToken, formData?.jenId || ""));
      dispatch(getAllUsertypeUserList(auth?.accessToken, 13, ''));
    }
  }, [auth?.accessToken, formData?.jenId, dispatch]);

  useEffect(() => {
    if (auth?.accessToken && (formData?.jenId || formData?.vendorId)) {
      dispatch(getMasterVehicleList(auth?.accessToken, formData?.jenId || "", formData?.vendorId || ""));
    }
  }, [auth?.accessToken, formData?.jenId, formData?.vendorId, dispatch]);

  useEffect(() => {
    if (auth?.accessToken && stateId) {
      dispatch(getAllCityStateWiseList(auth?.accessToken, stateId));
    }
  }, [auth?.accessToken, stateId, dispatch]);

  useEffect(() => {
    dispatch(getDriverListById(auth?.accessToken, id));
  }, [auth, id]);

  useEffect(() => {
    if (auth?.accessToken && roleCode) {
      dispatch(getAllUsersRoleWiseList(auth?.accessToken, roleCode));
    }
  }, [auth?.accessToken, roleCode, dispatch]);



  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
      const updatedpayload={
        id: id,
        driverId: formData?.driverId,
        driverName: formData?.driverName,
        mobileNumber: formData?.mobileNumber,
        address: formData?.address,
        dlNumber: formData?.dlNumber,
        password: formData?.password,
        aadhaarNumber: formData?.aadhaarNumber,
        dlExpiry: formData?.dlExpiry,
        vehicleId: formData?.vehicleId,
        vendorId: formData?.vendorId,
        jenId: formData?.jenId,
        cityCode: formData?.cityCode,
        stateCode: formData?.stateCode,
        threshold:Number( formData?.threshold),
      }
      dispatch(updateDriverData(auth?.accessToken, updatedpayload, id));
    }
    else {
      const payload={
    
        driverId: formData?.driverId,
        driverName: formData?.driverName,
        mobileNumber: formData?.mobileNumber,
        address: formData?.address,
        dlNumber: formData?.dlNumber,
        password: formData?.password,
        aadhaarNumber: formData?.aadhaarNumber,
        dlExpiry: formData?.dlExpiry,
        vehicleId: formData?.vehicleId,
        vendorId: formData?.vendorId,
        jenId: formData?.jenId,
        cityCode: formData?.cityCode,
        stateCode: formData?.stateCode,
        threshold:Number( formData?.threshold),
      }
      dispatch(saveDriverData(auth?.accessToken, payload));
    }
  };

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsDriver && Object.keys(errorsDriver).length > 0) {
      if (errorsDriver?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsDriver?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_DRIVER_STATUS' });
      }
      else if (errorsDriver?.status === 400) {
        // Handle other status
        if (errorsDriver?.data?.errors && Array.isArray(errorsDriver.data.errors)) {
          const transformedErrors = {};
          errorsDriver.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      }
      else {
        dispatch({ type: 'RESET_DELETE_DRIVER_STATUS' });
      }
    }
  }, [errorsDriver, dispatch]);

  useEffect(() => {
    if (id) {
      if (driverLists && Object.keys(driverLists).length > 0) {
        setFormData({
          driverId: driverLists?.driverId,
          driverName: driverLists?.driverName,
          mobileNumber: driverLists?.mobileNumber,
          address: driverLists?.address,
          dlNumber: driverLists?.dlNumber,
          password: driverLists?.password,
          aadhaarNumber: driverLists?.aadhaarNumber,
          dlExpiry: driverLists?.dlExpiry,
          vehicleId: driverLists?.vehicle?.id,
          vendorId: driverLists?.vendor?.id,
          jenId: driverLists?.jen?.id,
          cityCode: driverLists?.city?.nicCityCode,
          stateCode: driverLists?.state?.nicStateCode,
          threshold: driverLists?.threshold,
          status: driverLists?.status,
        });
      }
    }
  }, [driverLists]);

  useEffect(() => {
    if (changedDriverStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedDriverStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_DRIVER_STATUS' });
      navigate(-1);
    }
  }, [changedDriverStatus, dispatch, navigate]);

  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_DRIVER_STATUS' });
  }, [dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  // const selectHandler = (selectedData, name) => {
  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     [name]: selectedData[0].value,
  //   }));
  //   if (fieldErrors?.[name]) {
  //     setFieldErrors(prev => {
  //       const newErrors = { ...prev };
  //       delete newErrors[name];
  //       return newErrors;
  //     });
  //   }
  // };

   const selectHandler = (selectedData, name) => {
      if (name === "jenId") {
        setFormData(prevFormData => ({
          ...prevFormData,
          [name]: selectedData,
          vendorId: "" // Reset vendor when JEN changes
        }));
      } else {
        setFormData(prevFormData => ({
          ...prevFormData,
          [name]: selectedData
        }));
      }
    };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors?.data?.stateCode ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errors?.data?.stateCode ? 'red' : base.borderColor,
      }
    }),
  };

  const onDateChange = (name, value) => {
    if (value) {
      setFormData({ ...formData, [name]: getDateTimeMysqlGivenFormatYmd(value) });
    }
  };

  const transformedOptions = useMemo(() =>
    masterVehicleLists.map(vehicle => ({
      ...vehicle,
      concatenatedLabel: `${vehicle.vehicleNumber} - ${vehicle.vehicleType}` // Replace 'anotherField' with the actual field you want to concatenate
    })),
    [masterVehicleLists]
  );

  useEffect(() => { 
    setFieldErrors({});
  },[navigate,]);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
              { label: t("Driver"), path: "Driver" },
          { label: id ? t("Update Driver") : t("Add Driver"), path: "/Add-Driver", active: true },
        ]}
        title={id ? t("Update Driver") : t("Add Driver")}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              {errorsDriver?.data?.message && (
                <div className="alert alert-danger">
                  {errorsDriver?.data?.message}
                </div>
              )}

              <Row>
                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("J.E.N.")}</Form.Label>
                    <Select
                    
                       className={fieldErrors?.vendorId ? "border-danger" : ""}
                      options={masterUsersRoleWiseLists}
                      values={masterUsersRoleWiseLists?.filter(data => data?.id === formData.jenId)}
                      name="jenId"
                      labelField={"name"}
                      valueField={"id"}
                      searchBy="name"
                        onChange={(selectedData) => selectHandler(selectedData[0]?.id, "jenId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.jenId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.jenId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Vendor")}</Form.Label>
                    <Select
                       className={fieldErrors?.vendorId ? "border-danger" : ""}
                      options={masterVendorLists}
                      values={masterVendorLists?.filter(name => name?.vendorId === formData.vendorId)}
                      name="vendorId"
                      labelField={"vendorName"}
                      valueField={"vendorId"}
                      searchBy="vendorName"
                      onChange={(selectedData) => {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          vendorId: selectedData[0]?.vendorId

                        }));
                 
                      }}
                      styles={customSelectStyles}
                    />

                    {fieldErrors?.vendorId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.vendorId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

              
                              <Col lg={4}>
                                <Form.Group className="mb-3">
                                  <Form.Label>{t("Vehicle Number")}</Form.Label>
                                  <Select
                                    options={masterVehicleLists}
                                    className={fieldErrors?.vehicleId ? "border-danger" : " "}
                                    values={masterVehicleLists.filter((num) => num.vehicleId === formData.vehicleId)}
                                    name="vehicleNumber"
                                    labelField={"vehicleNumber"}
                                    valueField={"vehicleId"}
                                    onChange={(selectedData) => {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          vehicleId: selectedData[0]?.vehicleId,
                        }));
                      }}
                                    styles={customSelectStyles}
                                  />
                                  {fieldErrors?.vehicleId && (
                                    <div className="invalid-feedback d-block">
                                      <p className="text-danger">{fieldErrors?.vehicleId}</p>
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                {(!id) && (
                  <>
                    <Col lg={4}>
                      <FormInput
                        label={t("Driver ID")}
                        type="text"
                        errors={fieldErrors}
                        value={formData.driverId}
                        name="driverId"
                        onChange={inputHandlerCaps}
                        containerClass={"mb-3"}
                      />
                    </Col>
                  </>
                )}


                <Col lg={4}>
                  <FormInput
                    label={t("Driver Name")}
                    type="text"
                    errors={fieldErrors}
                    value={formData?.driverName}
                    name="driverName"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Mobile Number")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.mobileNumber}
                    name="mobileNumber"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("State")}</Form.Label>
                    <Select
                       className={fieldErrors?.stateCode ? "border-danger" : ""}
                      options={masterStateLists}
                      values={masterStateLists?.filter(state => state?.stateCode === formData.stateCode)}
                      name="stateCode"
                      labelField={"stateName"}
                      valueField={"stateCode"}
                      searchBy={"stateName"}
                      onChange={(selectedData) => {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          stateCode: selectedData[0]?.stateCode,
                        }));
                        setStateId(selectedData[0]?.stateCode);
                      }}
                      styles={customSelectStyles}
                    />

                    {fieldErrors?.stateCode && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.stateCode}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("City")}</Form.Label>
                    <Select
                       className={fieldErrors?.cityCode ? "border-danger" : ""}
                      options={masterCityStateWiseLists}
                      values={masterCityStateWiseLists?.filter(city => city.cityCode === formData.cityCode)}
                      name="cityCode"
                      labelField={"cityName"}
                      valueField={"cityCode"}
                      searchBy={"cityName"}
                      onChange={(selectedData) => {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          cityCode: selectedData[0]?.cityCode,
                        }));
                      }}
                      styles={customSelectStyles}
                    />

                    {fieldErrors?.cityCode && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.cityCode}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Address")}
                    type="text"
                    errors={fieldErrors}
                    value={formData?.address}
                    name="address"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("DL Number")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.dlNumber}
                    name="dlNumber"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>


                <Col lg={4}>
                  <FormInput
                    label={t("Aadhaar Number")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.aadhaarNumber}
                    name="aadhaarNumber"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Password")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.password}
                    name="password"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("D.L. Expiry")}</Form.Label>
                    <DatePicker
                      selected={formData.dlExpiry}
                      onChange={(value) => setFormData({ ...formData, dlExpiry: getDateTimeMysqlGivenFormatYmd(value) })}
                      dateFormat="yyyy-MM-dd" // Display the date in yyyy-MM-dd format
                      maxDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear() + 5);  // Subtract 18 years
                        return date;
                      })()}
                      minDate={(() => {
                        const date = new Date();
                        date.setFullYear(date.getFullYear());  // Subtract 18 years
                        return date;
                      })()}
                       className={fieldErrors?.dlExpiry? "form-control border-danger" : "form-control"}
                      withPortal
                      showYearDropdown
                      scrollableYearDropdown
                    />

                    {fieldErrors?.dlExpiry && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.dlExpiry}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
                  
        <Col lg={4}>
                  <FormInput
                    label={t("Threshold")}
                    type="number"
                    min={0}
                    max={100}
                    errors={fieldErrors}
                    value={formData?.threshold}
                    name="threshold"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

              </Row>

              <div className="d-flex justify-content-center">
                {loading ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      
      </Row>
      {loadingDriver && (<Preloader />)}
      {loadingMaster && (<Preloader />)}

    </>
  );
};

export default Dashboard;
